"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const provider_components_1 = require("@kyruus/provider-components");
const util_1 = require("../common/util");
const ProviderReferralButton_styles_1 = require("./ProviderReferralButton.styles");
const ProviderReferralButton = (_a) => {
    var { referrals, hasMaxReferrals, canRefer, labels: { referButtonLabel = 'Refer', removeReferralButtonLabel = 'Remove referral', referredButtonLabel = 'Referred' } = {}, onAddReferral, onRemoveReferral, referableProvider } = _a, rest = __rest(_a, ["referrals", "hasMaxReferrals", "canRefer", "labels", "onAddReferral", "onRemoveReferral", "referableProvider"]);
    const providerContent = (0, provider_components_1.useProviderContent)(referableProvider);
    const isReferred = (0, util_1.isProviderReferred)(referableProvider, referrals);
    const toggleReferredProvider = react_1.default.useCallback(() => {
        if (isReferred) {
            onRemoveReferral(referableProvider);
        }
        else {
            onAddReferral(referableProvider);
        }
    }, [isReferred, onAddReferral, onRemoveReferral, referableProvider]);
    const ariaLabel = react_1.default.useMemo(() => {
        return `${isReferred ? removeReferralButtonLabel : referButtonLabel} ${providerContent.name || ''} ${providerContent.locationName || ''}`;
    }, [
        isReferred,
        providerContent.locationName,
        providerContent.name,
        referButtonLabel,
        removeReferralButtonLabel
    ]);
    const buttonContent = react_1.default.useMemo(() => {
        if (isReferred) {
            return (react_1.default.createElement("span", null,
                referredButtonLabel,
                react_1.default.createElement(ProviderReferralButton_styles_1.CheckCircleIcon, { size: "1em", color: "white", "aria-hidden": true })));
        }
        return referButtonLabel;
    }, [isReferred, referButtonLabel, referredButtonLabel]);
    return (react_1.default.createElement(ProviderReferralButton_styles_1.ToggleButton, Object.assign({ onClick: toggleReferredProvider, disabled: !canRefer || (!isReferred && hasMaxReferrals), "aria-pressed": isReferred, "aria-label": ariaLabel, isReferred: isReferred }, rest), buttonContent));
};
exports.default = ProviderReferralButton;
//# sourceMappingURL=ProviderReferralButton.js.map